import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const environment = process.env.REACT_APP_ENVIRONMENT === 'production' ? 'prod' : 'dev';
const baseUrl = process.env.REACT_APP_I18N_BASE_URL;

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: process.env.NODE_ENV === 'development',
    fallbackLng: 'en-US',
    defaultNS: 'common',
    ns: ['common', 'myAccount'],
    load: 'currentOnly',
    supportedLngs: ['en-US', 'es'],
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator'],
      caches: ['cookie', 'localStorage'],
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
    },
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: (lngs: string[], namespaces: string[]) => {
        const lng = lngs[0] === 'en-US' ? 'en' : lngs[0];
        return `${baseUrl}/api/${environment}/${namespaces[0]}/${lng}/`;
      },
    },
  });

export default i18n;
